<template lang="pug">
  v-layout.column(v-rc-loader="loading")
    v-layout(v-if="products.length")
      v-flex.xs3.lg2.scroll-y-overflow.elevation-1.my-1.roles-menu.align-self-start
        v-list.py-0
          v-list-tile.product-tile(
            v-for="product in products"
            :key="product"
            :class="{ 'selected-product': currentProduct === product }"
            @click="currentProduct = product"
          )
            |{{ product }}
      v-flex.xs9.lg10.scroll-y-overflow.py-1.pl-4.roles-cb-wrap
        .elevation-2(style="min-height: 100%;")
          v-layout.align-baseline.wrap.px-5(v-if="currentProduct")
            v-flex.xs6.align-self-start(v-for="role in affectableRoles.filter(it => it.category_name === currentProduct)" :key="role.tpl_id")
              v-checkbox(
                hide-details
                :label="role.display_name"
                color="primary"
                @change="roleChange(role.tpl_id)"
                :input-value="!toRemoveIds.includes(role.tpl_id)"
              )
    v-layout.justify-center.pa-5.font-italic.text-xs-center.subheading.grey--text.text--darken-2(v-else)
      span Il n'y a pas de droits à affecter à ce contact.
</template>

<script>
import axios from 'axios';
import apiRoleService from '@/services/api/common/roleService';

export default {
  props: {
    user: {
      type: Object,
      default: () => {},
    },
    useDestinationId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      currentProduct: null,
      affectableRoles: [],
      type: this.$route.meta.type,
      products: [],
      toRemoveIds: [],
      loading: true,
    }
  },
  mounted() {
    this.getAffectable().then(() => {
      this.loading = false;
    });
  },
  methods: {
    roleChange(roleId) {
      const idx = this.toRemoveIds.indexOf(roleId);
      if (idx === -1) {
        this.toRemoveIds.push(roleId);
      } else {
        this.toRemoveIds.splice(idx, 1);
      }
    },
    async getAffectable() {
      this.affectableRoles = this.$route.path.startsWith('/users') ? await apiRoleService.getAssignableToUser() : await apiRoleService.getAssignableToContact(this.user.parent_id);
      this.products = [...new Set(this.affectableRoles.map(it => it.category_name))]
        .filter(x => !!x)
        .sort((a, b) => a.localeCompare(b));
      this.currentProduct = this.products[0] || null;
    },
  },
}
</script>

<style lang="scss" scoped>
  .roles-cb-wrap {
    border-right: 1px solid #efefef;
    height: 300px;
  }
  .roles-menu {
    border-left: 2px solid #efefef;
    height: 292px;
  }
  .product-tile {
    transition: none;
    border-bottom: 1px solid lightgrey;
  }
  .selected-product {
    background-color: var(--primary);
    color: white;
    i {
      color: white!important;
    }
    transition: none;
  }
</style>

